import { MANUAL_PAYMENT } from './ManualPaymentModal.actions';
import { mergeStates } from '../../../iwProvider/StoreHelper';

const initialState = {
    amount: 0,
    accountNumber: '',
    sortCode: '',
    iban: '',
    name: '',
    reference: '',
    accountId: ''
};

type TState = {
    amount: number;
    accountNumber: string;
    sortCode: string;
    iban: string;
    name: string;
    reference: string;
    accountId: string;
};

type TAction = {
    type: typeof MANUAL_PAYMENT;
    amount: number;
    accountNumber?: string;
    sortCode?: string;
    iban?: string;
    name: string;
    reference: string;
    accountId: string;
};

// eslint-disable-next-line import/no-default-export
export default function (
    state: TState = mergeStates(initialState),
    action: TAction
): TState {
    switch (action.type) {
        case MANUAL_PAYMENT:
            return mergeStates(state, {
                amount: action.amount,
                manualPaymentConfirmed: false,
                accountNumber: action.accountNumber,
                sortCode: action.sortCode,
                iban: action.iban,
                name: action.name,
                reference: action.reference,
                accountId: action.accountId
            });
        default:
            return state;
    }
}
